var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7225_3305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 18,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3538 1H3V23H20.3538V1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7225_3305)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7225_3305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 18,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 1H4.62692C3.73212 1 3 1.675 3 2.5V21.5C3 22.325 3.73212 23 4.62692 23H18.7269C19.6217 23 20.3538 22.325 20.3538 21.5V6.99999L13.8462 1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7225_3305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 1H4.62692C3.73212 1 3 1.675 3 2.5V21.5C3 22.325 3.73212 23 4.62692 23H18.7269C19.6217 23 20.3538 22.325 20.3538 21.5V6.99999L16.5577 4.5L13.8462 1Z",
    fill: "#4285F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7225_3305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 18,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 1H4.62692C3.73212 1 3 1.675 3 2.5V21.5C3 22.325 3.73212 23 4.62692 23H18.7269C19.6217 23 20.3538 22.325 20.3538 21.5V6.99999L13.8462 1Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7225_3305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.322 6.56125L20.3538 12.1212V6.99999L14.322 6.56125Z",
    fill: "url(#paint0_linear_7225_3305)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7225_3305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 18,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 1H4.62692C3.73212 1 3 1.675 3 2.5V21.5C3 22.325 3.73212 23 4.62692 23H18.7269C19.6217 23 20.3538 22.325 20.3538 21.5V6.99999L13.8462 1Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7225_3305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33847 17H16.0154V16H7.33847V17ZM7.33847 19H13.8462V18H7.33847V19ZM7.33847 12V13H16.0154V12H7.33847ZM7.33847 15H16.0154V14H7.33847V15Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_7225_3305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 18,
    height: 22
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 1H4.62692C3.73212 1 3 1.675 3 2.5V21.5C3 22.325 3.73212 23 4.62692 23H18.7269C19.6217 23 20.3538 22.325 20.3538 21.5V6.99999L13.8462 1Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_7225_3305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 1V5.49999C13.8462 6.32875 14.5742 6.99999 15.4731 6.99999H20.3539L13.8462 1Z",
    fill: "#A1C2FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_7225_3305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 18,
    height: 22
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 1H4.62692C3.73212 1 3 1.675 3 2.5V21.5C3 22.325 3.73212 23 4.62692 23H18.7269C19.6217 23 20.3538 22.325 20.3538 21.5V6.99999L13.8462 1Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_7225_3305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.62692 1C3.73212 1 3 1.675 3 2.5V2.625C3 1.8 3.73212 1.125 4.62692 1.125H13.8462V1H4.62692Z",
    fill: "white",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_7225_3305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 18,
    height: 22
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 1H4.62692C3.73212 1 3 1.675 3 2.5V21.5C3 22.325 3.73212 23 4.62692 23H18.7269C19.6217 23 20.3538 22.325 20.3538 21.5V6.99999L13.8462 1Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_7225_3305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7269 22.875H4.62692C3.73212 22.875 3 22.2 3 21.375V21.5C3 22.325 3.73212 23 4.62692 23H18.7269C19.6217 23 20.3538 22.325 20.3538 21.5V21.375C20.3538 22.2 19.6217 22.875 18.7269 22.875Z",
    fill: "#1A237E",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_7225_3305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 18,
    height: 22
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 1H4.62692C3.73212 1 3 1.675 3 2.5V21.5C3 22.325 3.73212 23 4.62692 23H18.7269C19.6217 23 20.3538 22.325 20.3538 21.5V6.99999L13.8462 1Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_7225_3305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4731 6.99999C14.5742 6.99999 13.8462 6.32875 13.8462 5.49998V5.62499C13.8462 6.45375 14.5742 7.12499 15.4731 7.12499H20.3539V6.99999H15.4731Z",
    fill: "#1A237E",
    fillOpacity: 0.1
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 1H4.62692C3.73212 1 3 1.675 3 2.5V21.5C3 22.325 3.73212 23 4.62692 23H18.7269C19.6217 23 20.3538 22.325 20.3538 21.5V6.99999L13.8462 1Z",
    fill: "url(#paint1_radial_7225_3305)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7225_3305",
    x1: 17.3383,
    y1: 7.03865,
    x2: 17.3383,
    y2: 12.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7225_3305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.54978 1.43483) scale(27.9828 25.6509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.65053b2ff3f86bf0a43629a0a292e1a5.svg";
export { ForwardRef as ReactComponent };